<div class="yellowMask">

    <div class="headerContainer">
        <div id="headerLogo"
             class="linkLogo"
             title="Zur Anmeldeseite"
             (click)="backToLogin()"></div>

        <h1 style="
            font-size: 1.6rem;
            color: white;
            line-height: 85px;
            font-family: 'Roboto', helvetica, arial, sans-serif;
            float: left;
            margin-left: 15px;
        ">Kreditportal</h1>

        <button class="headerButton btn-yellow-white" (click)="fwHilfe()"><span class="hilfe"></span></button>
        <button class="headerButton btn-yellow-white" (click)="fwKautionsPage()"><span>Zur Kautions-Produktseite</span></button>
    </div>

    <div class="contentContainer">

        <h1>Sie sind vom Kreditportal abgemeldet.</h1>
        <div class="gridContainer formGrid loginGrid">
            <div class="row">
                <div class="cell grid-100">
                    <elem-button buttonRole="PRIMARY" class="expand register-btn" (click)="backToLogin()">Zurück zur Anmeldung</elem-button>
                </div>
            </div>


        </div>
    </div>

    <extern-footer class="pageYellow"></extern-footer>

</div>

